import { render, staticRenderFns } from "./Notificationpage.vue?vue&type=template&id=451cf6da&scoped=true&"
import script from "./Notificationpage.vue?vue&type=script&lang=js&"
export * from "./Notificationpage.vue?vue&type=script&lang=js&"
import style0 from "./Notificationpage.vue?vue&type=style&index=0&id=451cf6da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451cf6da",
  null
  
)

export default component.exports